<div class="dialog-pqr">
  <div class="header">
    <h2 mat-dialog-title>Valores do padrão de qualidade de referência - PQR</h2>

    <mat-dialog-actions>
      <button mat-dialog-close class="close-x-button">×</button>
    </mat-dialog-actions>
  </div>

  <mat-dialog-content>
    <h1 class="title">Serviços, infraestrutura e recursos</h1>
    <div class="panel">
      <app-tabela
        ngSkipHydration
        class="table-component"
        [cabecalhoCustomizado]="true"
      >
        <ng-container cabecalho>
          <tr>
            <th class="table-header" style="width: 12%">Sequence</th>
            <th class="table-header" style="width: 68%">Item</th>
            <th class="table-header" style="width: 20%">Percentual (%)</th>
          </tr>
        </ng-container>
        <ng-container corpo>
          <tr *ngFor="let dado of dados">
            <td class="table-cell">{{ dado.id }}</td>
            <td class="table-cell">
              <input
                [value]="dado.descricaoItem"
                class="display-input align-left"
                disabled="true"
              />
            </td>
            <td class="table-cell">
              <input
                [value]="dado.percentual"
                class="display-input text-green"
                disabled="true"
              />
            </td>
          </tr>
        </ng-container>
      </app-tabela>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="footer">
    <button class="close-button" mat-dialog-close>Fechar</button>
  </mat-dialog-actions>
</div>
